module.exports = __webpack_public_path__ + "b5e691880d15f2ee64a4cede97a46b62.svg";